<template>
  <div class="tabs-wrapper d-flex flex-row align-items-center text-uppercase" :class="callerComp === 'search' && isProductsLoad ? 'search-product-loading' : ''" v-if="bannerPlaceHolderForComboTab || bannerPlaceHolderForKidsTab">
    <div
      v-if="bannerPlaceHolderForComboTab && showMenWebMenu && anyTwoGenderKeysTrue && !isKidsGenderRouteActive"
      class="col d-flex flex-row align-items-center justify-content-center gender-text-container"
      :class="[tabsCountDataArr[0].is_men  ? 'active-tab-class' :  'd-active-tab-class']"
      @click="updateLandingCategory('men')"
    >
    <div class="gender-text-wrapper" :class="selectedGender === 'men' ? 'selected-tab-class' : ''">
      <span class="gender-text">Men</span>
    </div>
        
    </div>
    <div 
    v-if="bannerPlaceHolderForComboTab && showWomenWebMenu && anyTwoGenderKeysTrue && !isKidsGenderRouteActive"
    class="col d-flex flex-row align-items-center justify-content-center gender-text-container" 
    :class="[tabsCountDataArr[0].is_women  ? 'active-tab-class' : 'd-active-tab-class']"
    @click="updateLandingCategory('women')"
    >
    <div class="gender-text-wrapper" :class="selectedGender === 'women' ? 'selected-tab-class' : ''">
        <span class="gender-text">Women</span>
    </div>
    </div>
    <div v-if="bannerPlaceHolderForKidsTab && showKidsWebMenu && anyTwoGenderKeysTrue && !isKidsGenderRouteActive"
     class="col d-flex flex-row align-items-center justify-content-center gender-text-container" 
     :class="[tabsCountDataArr[0].is_kids ? 'active-tab-class' : 'd-active-tab-class']"
     @click="updateLandingCategory('kids')"
    >
    <div class="gender-text-wrapper" :class="selectedGender === 'kids' ? 'selected-tab-class' : ''">
        <span class="gender-text">Kids</span>
    </div>
    </div>
    <div
    v-if="isKidsGenderRouteActive"
     class="col d-flex flex-row align-items-center justify-content-center gender-text-container" 
     :class="[tabsCountDataArr[0].is_kids ? 'active-tab-class' : 'd-active-tab-class']"
     @click="updateLandingCategory('boys')"
    >
    <div class="gender-text-wrapper" :class="selectedGender === 'boys' ? 'selected-tab-class' : ''">
        <span class="gender-text">Boys</span>
    </div>
    </div>
    <div
    v-if="isKidsGenderRouteActive"
     class="col d-flex flex-row align-items-center justify-content-center gender-text-container" 
     :class="[tabsCountDataArr[0].is_kids ? 'active-tab-class' : 'd-active-tab-class']"
     @click="updateLandingCategory('girls')"
    >
    <div class="gender-text-wrapper" :class="selectedGender === 'girls' ? 'selected-tab-class' : ''">
        <span class="gender-text">Girls</span>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
export default {
  props: [
    'searchTerm',
    'tabsCountDataArr',
    'callerComp',
    'isProductsLoad',
    'isKids'
  ],
  data () {
    return {
      isGenderTab: 0,
      tabsCountData: {},
      selectedGender: '',
      isTabActive: true,
      isKidsGenderActive: false,
      isKidsGenderRouteActive: false
    }
  },
  methods: {
    updateLandingCategory (cat, event) {
      if (cat && cat.length > 0) {
        switch (cat) {
          case 'men':
            this.isTabActive = this.tabsCountDataArr[0].is_men
            Vue.ls.set('tss_landingCategory', 'men')
            break
          case 'women':
            this.isTabActive = this.tabsCountDataArr[0].is_women
            Vue.ls.set('tss_landingCategory', 'women')
            break
          case 'kids':
            this.isTabActive = this.tabsCountDataArr[0].is_kids
            Vue.ls.set('tss_landingCategory', 'kids')
            break
        }
        if (this.isTabActive) {
          if (this.selectedGender === cat) {
            this.selectedGender = ''
          } else {
            this.selectedGender = cat
          }
          if (this.callerComp === 'search') {
            this.$emit('updateLandingCategory', {'search': this.searchTerm, 'isKids': ['kids', 'boys', 'girls'].includes(this.selectedGender), 'gender': this.selectedGender === 'boys' ? 'men' : this.selectedGender === 'girls' ? 'women' : ['kids', 'boys', 'girls'].includes(this.selectedGender) ? 'kids' : this.selectedGender})
          } else {
            Vue.ls.set('listCache_header', '')
            this.$emit('updateLandingCategory', {'isKids': ['kids', 'boys', 'girls'].includes(this.selectedGender), 'gender': this.selectedGender === 'boys' ? 'men' : this.selectedGender === 'girls' ? 'women' : ['kids', 'boys', 'girls'].includes(this.selectedGender) ? 'kids' : this.selectedGender})
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['webcategory', 'bannerPlcaeHolderData', 'isKidsGenderTabActive', 'isComboGenderTabActive', 'globalBannerPlaceholder', 'isSelectedCountryIndia']),
    bannerPlaceHolderForComboTab: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'SHOW_COMBO_GENDER_TABS'.toLowerCase())
    },
    bannerPlaceHolderForKidsTab: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'SHOW_KIDS_TAB'.toLowerCase())
    },
    showWomenWebMenu: function () {
      return this.isSelectedCountryIndia ? true : this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_WEB_MENU_WOMEN')
    },
    showMenWebMenu: function () {
      return this.isSelectedCountryIndia ? true : this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_WEB_MENU_MEN')
    },
    showKidsWebMenu: function () {
      return this.isSelectedCountryIndia ? true : this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_WEB_MENU_KIDS')
    },
    anyTwoGenderKeysTrue () {
      const object = this.tabsCountDataArr[0]
      const keys = Object.keys(object)
      for (let i = 0; i < keys.length - 1; i++) {
        for (let j = i + 1; j < keys.length; j++) {
          if (object[keys[i]] && object[keys[j]]) {
            return true
          } else if (!object[keys[i]] && !object[keys[j]] && object.is_kids) {
            return false
          }
        }
      }
      return false
    }
  },
  watch: {
    tabsCountDataArr () {
      this.tabsCountData = this.tabsCountDataArr && this.tabsCountDataArr[0]
    },
    isKids (newVal) {
      if (newVal) {
        this.isKidsGenderRouteActive = true
      }
    }
  },
  mounted () {
    const routePath = this.$route.path
    const firstPart = routePath.split('/')[1]
    if (firstPart === 'kids' || this.isKids) {
      this.isKidsGenderRouteActive = true
    }
  }
}
</script>

<style scoped>
.tabs-wrapper {
    background-color: #e1e1e1;
    min-height: 45px;
}
.gender-text {
    font-size: 15px;
    color: #0a0a0a;
    margin: auto;
    font-weight: normal;
  }
.active-tab-class {
  position: relative;
    background-color: #ffffff !important;
    min-height: 45px;
    padding: 0px !important;
}
.active-tab-class:after {
    height: 23px;
    content: "";
    right: 0px;
    position: absolute;
    border-right: 1px solid #cbc6c6;
}
.d-active-tab-class:after {
    height: 23px;
    content: "";
    right: 0px;
    position: absolute;
    border-right: 1px solid #cbc6c6;
}
.active-tab-class:last-child::after {
content: none;
}
.selected-tab-class .gender-text {
  font-weight: 600;
}
.d-active-tab-class {
    background-color: #efeeee !important;
    min-height: 45px !important;
    font-weight: 600;
    padding: 0px !important;
}
.d-active-tab-class .gender-text {
  color: #d8cfcf !important;
}
.selected-tab-class{
  border-bottom: 4px solid #187b7b;
  color: #0a0a0a !important;
  font-weight: 600;
}
.gender-text-wrapper {
  width: 100%;
  display: flex;
  min-height: 45px;
}
.search-product-loading .gender-text-container {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// GenderTabs.vue?cda82c26